module.exports = __webpack_public_path__ + "static/media/08.4cb8a94b.png";